(function () {
  var root = document.querySelector("[data-ggw-sticky-atc]");
  if (!root) return;

  // Leave the product column so position:fixed pins to the phone, not the product block.
  if (root.parentNode !== document.body) {
    document.body.appendChild(root);
  }

  var mq = window.matchMedia("(max-width: 749px)");
  var btn = root.querySelector("[data-ggw-sticky-atc-btn]");
  var price = root.querySelector("[data-ggw-sticky-atc-price]");
  var formId = root.getAttribute("data-form-id");
  var form = formId ? document.getElementById(formId) : null;
  var mainBtn = form
    ? form.querySelector(".product-form__submit")
    : document.querySelector(".product-form__submit");

  if (!mainBtn || !btn) return;

  var seen = false;

  function mobile() {
    return mq.matches;
  }

  function sync() {
    var livePrice = document.querySelector(
      ".product .price-item--sale, .product .price-item--regular, .price .price-item--regular, .price-item--regular"
    );
    if (price && livePrice) {
      price.textContent = livePrice.textContent.trim();
    }
    var label = mainBtn.querySelector("span");
    if (label) btn.textContent = label.textContent.trim();
    btn.disabled = mainBtn.disabled || mainBtn.getAttribute("aria-disabled") === "true";
  }

  function setVisible(on) {
    var show = on && mobile();
    root.classList.toggle("is-visible", show);
    document.body.classList.toggle("ggw-sticky-atc-pad", show);
  }

  btn.addEventListener("click", function () {
    if (btn.disabled) return;
    if (typeof mainBtn.click === "function") mainBtn.click();
  });

  var observer = new IntersectionObserver(
    function (entries) {
      var entry = entries[0];
      if (!entry) return;
      if (entry.isIntersecting) seen = true;
      setVisible(seen && !entry.isIntersecting);
    },
    { threshold: 0, rootMargin: "0px" }
  );

  observer.observe(mainBtn);
  setVisible(false);
  sync();

  document.addEventListener("variant:change", sync);
  document.addEventListener("change", function (e) {
    if (e.target && (e.target.closest(".product-form") || e.target.name === "id")) sync();
  });

  if (mq.addEventListener) {
    mq.addEventListener("change", function () {
      if (!mobile()) setVisible(false);
    });
  }

  var productInfo = document.querySelector("product-info");
  if (productInfo) {
    productInfo.addEventListener("variant:change", sync);
  }
})();
